import { read } from '@/api/rest';

const briefcaseQuality = {
  stats: async (params) =>
    await read('/briefcase-quality/stats?' + params.toString()),
};
export default briefcaseQuality;
